<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-system-permissions"
      v-model="allSelected"
      name="select-all-menu-system-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item v-for="(option, index) in systemOptions" :key="index">
        <div v-if="option.children">
          <p class="h5">{{ option.label }}</p>
          <div class="row">
            <div
              v-for="(optionChildren, indexChildren) in option.children"
              :key="indexChildren"
              class="col-6"
            >
              <b-form-checkbox
                :id="`option-${optionChildren.value}`"
                v-model="itemData.SystemMenuAccess"
                :name="optionChildren.value"
                class="text-capitalize"
                switch
                :value="optionChildren.value"
              >
                {{ optionChildren.label }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <b-form-checkbox
          v-else
          :id="`option-system-${index}`"
          v-model="itemData.SystemMenuAccess"
          :name="`option-system-${index}`"
          class="text-capitalize"
          switch
          :value="option.value"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const systemOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.system.system_management'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.system.product_information'),
            value: 'SystemManagement'
          }
        ]
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.system.log'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.system.system_log'),
            value: 'SystemLog'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.system.event_log'),
            value: 'EventLog'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.system.export_log'),
            value: 'BackupLog'
          }
        ]
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.system.date_time_laguage'),
        value: 'DateTimeLanguage'
      }
    ];

    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "SystemMenuAccess",
      flattenOptionValues(systemOptions)
    );

    return { allSelected, systemOptions }
  }
}
</script>
